var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "203px",
    height: "18px",
    viewBox: "0 0 203 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview---Monthly-View",
    transform: "translate(-188.000000, -49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(188.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RR_Logo_Lsp1_Rev"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#35B399",
    fillRule: "nonzero",
    x: 0.394841438,
    y: 13.4385366,
    width: 4.28317125,
    height: 4.38146341
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#35B399",
    fillRule: "nonzero",
    x: 6.86680761,
    y: 9.05707317,
    width: 4.28317125,
    height: 8.76292683
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#35B399",
    fillRule: "nonzero",
    x: 13.2572304,
    y: 4.67560976,
    width: 4.28317125,
    height: 13.1443902
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#35B399",
    fillRule: "nonzero",
    x: 19.6819873,
    y: 0.294146341,
    width: 4.28317125,
    height: 17.5258537
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3724736,17.495122 L40.7030021,12.6921951 L37.4798943,12.6921951 L37.4798943,17.495122 L34.5314588,17.495122 L34.5314588,5.64146341 C34.5384527,4.81278497 35.1934425,4.14276421 36.0035307,4.13560976 L41.8961099,4.13560976 C43.0283865,4.10219673 44.1252638,4.54124127 44.9346912,5.35185576 C45.7441186,6.16247025 46.1964934,7.27494971 46.1878647,8.43365854 C46.1790684,10.0774301 45.2377784,11.5663133 43.7758985,12.2487805 L46.7415011,17.495122 L43.3724736,17.495122 Z M41.2909725,6.54146341 L37.4798943,6.54146341 L37.4798943,10.3390244 L41.2909725,10.3390244 C41.7924206,10.3449689 42.2750276,10.1438223 42.6296287,9.78108358 C42.9842298,9.4183449 43.180864,8.92466283 43.1750529,8.41170732 C43.1801605,7.90409578 42.98143,7.41657539 42.6252946,7.06305543 C42.2691592,6.70953547 41.7868189,6.52098664 41.2909725,6.54146341 L41.2909725,6.54146341 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "49.6985201 17.495122 49.6985201 4.11365854 52.6469556 4.11365854 52.6469556 17.495122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6596195,17.7146341 C58.7970402,17.7146341 55.685518,14.8214634 55.685518,10.8043902 C55.685518,6.54585366 58.6339535,3.91170732 62.8742072,3.91170732 C64.3209042,3.92125008 65.7557426,4.17948186 67.1187526,4.67560976 L66.5221987,7.18682927 C65.4371022,6.83029921 64.3092756,6.62792014 63.1703383,6.58536585 C60.1274841,6.58536585 58.6339535,8.07365854 58.6339535,10.8043902 C58.6339535,13.1970732 60.1875687,15.0453659 62.6596195,15.0453659 C63.6700699,15.1142722 64.6575297,14.7163459 65.3505497,13.9609756 L65.3505497,10.6814634 L68.2389006,10.6814634 L68.2389006,14.5404878 C67.3805497,16.2702439 65.2346723,17.7146341 62.6596195,17.7146341 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "80.3974419 17.495122 80.3974419 12.0907317 74.5434884 12.0907317 74.5434884 17.495122 71.5950529 17.495122 71.5950529 4.11365854 74.5434884 4.11365854 74.5434884 9.41707317 80.3974419 9.41707317 80.3974419 4.11365854 83.3244186 4.11365854 83.3244186 17.495122"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "93.6975899 6.74341463 93.6975899 17.495122 90.7491543 17.495122 90.7491543 6.74341463 86.4573996 6.74341463 86.4573996 4.10926829 97.9893446 4.10926829 97.9893446 6.74341463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.182114,17.495122 L112.512643,12.6921951 L109.289535,12.6921951 L109.289535,17.495122 L106.341099,17.495122 L106.341099,5.64146341 C106.348093,4.81278497 107.003083,4.14276421 107.813171,4.13560976 L113.731501,4.13560976 C114.863778,4.10219673 115.960655,4.54124127 116.770082,5.35185576 C117.57951,6.16247025 118.031884,7.27494971 118.023256,8.43365854 C118.022062,10.0864073 117.077595,11.5862429 115.606998,12.2707317 L118.5726,17.5170732 L115.182114,17.495122 Z M113.100613,6.54146341 L109.289535,6.54146341 L109.289535,10.3390244 L113.100613,10.3390244 C113.602061,10.3449689 114.084668,10.1438223 114.439269,9.78108358 C114.79387,9.4183449 114.990505,8.92466283 114.984693,8.41170732 C114.989801,7.90409578 114.791071,7.41657539 114.434935,7.06305543 C114.0788,6.70953547 113.596459,6.52098664 113.100613,6.54146341 L113.100613,6.54146341 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.881522,17.495122 C122.071434,17.4879675 121.416444,16.8179467 121.40945,15.9892683 L121.40945,5.6195122 C121.416444,4.79083375 122.071434,4.12081299 122.881522,4.11365854 L131.014397,4.11365854 L131.014397,6.70390244 L124.357886,6.70390244 L124.357886,9.37756098 L129.130317,9.37756098 C129.841398,9.37756098 130.417844,9.96723472 130.417844,10.6946341 C130.41794,11.0411851 130.28134,11.373116 130.038978,11.615255 C129.796616,11.857394 129.468997,11.989255 129.130317,11.9809756 L124.357886,11.9809756 L124.357886,14.9136585 L131.018689,14.9136585 L131.018689,17.5039024 L122.881522,17.495122 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.426195,16.7707317 C141.209954,17.2845351 140.715558,17.617422 140.16871,17.617422 C139.621863,17.617422 139.127467,17.2845351 138.911226,16.7707317 L133.864123,4.11365854 L136.769641,4.11365854 L140.16871,12.635122 L143.56778,4.11365854 L146.473298,4.11365854 L141.426195,16.7707317 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.696385,17.495122 C149.886297,17.4879675 149.231307,16.8179467 149.224313,15.9892683 L149.224313,5.6195122 C149.231307,4.79083375 149.886297,4.12081299 150.696385,4.11365854 L158.82926,4.11365854 L158.82926,6.70390244 L152.168457,6.70390244 L152.168457,9.37756098 L156.940888,9.37756098 C157.651969,9.37756098 158.228414,9.96723472 158.228414,10.6946341 C158.228511,11.0411851 158.091911,11.373116 157.849548,11.615255 C157.607186,11.857394 157.279568,11.989255 156.940888,11.9809756 L152.168457,11.9809756 L152.168457,14.9136585 L158.82926,14.9136585 L158.82926,17.5039024 L150.696385,17.495122 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.28389,17.5960976 C172.79552,17.6799529 172.299336,17.5008105 171.970613,17.1219512 L165.50723,9.35560976 L165.50723,17.495122 L162.558795,17.495122 L162.558795,5.47902439 C162.556512,5.07615205 162.710776,4.68885327 162.987649,4.40233281 C163.264522,4.11581235 163.641324,3.95354152 164.035159,3.95121951 C164.470008,3.92524908 164.889301,4.12080834 165.155307,4.47365854 C165.155307,4.47365854 167.198182,6.94536585 171.618689,12.1917073 L171.618689,4.11365854 L174.567125,4.11365854 L174.567125,16.1078049 C174.568418,16.86431 174.017794,17.502922 173.28389,17.5960976 L173.28389,17.5960976 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.184947,17.7146341 C180.631374,17.7146341 178.292368,15.0234146 178.292368,11.9282927 L178.292368,4.11365854 L181.240803,4.11365854 L181.240803,11.9282927 C181.240803,13.8556098 182.476829,15.0014634 184.189239,15.0014634 C185.901649,15.0014634 187.116216,13.8380488 187.116216,11.9282927 L187.116216,4.11365854 L190.064651,4.11365854 L190.064651,11.9282927 C190.060359,15.0234146 187.742812,17.7146341 184.184947,17.7146341 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.871416,17.495122 C194.061328,17.4879675 193.406339,16.8179467 193.399345,15.9892683 L193.399345,5.6195122 C193.406339,4.79083375 194.061328,4.12081299 194.871416,4.11365854 L203,4.11365854 L203,6.70390244 L196.343488,6.70390244 L196.343488,9.37756098 L201.11592,9.37756098 C201.827001,9.37756098 202.403446,9.96723472 202.403446,10.6946341 C202.403543,11.0411851 202.266942,11.373116 202.02458,11.615255 C201.782218,11.857394 201.4546,11.989255 201.11592,11.9809756 L196.343488,11.9809756 L196.343488,14.9136585 L203,14.9136585 L203,17.5039024 L194.871416,17.495122 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a6db2a88500063e1033b6c08185b768.svg";
export { ForwardRef as ReactComponent };